import React, { useEffect } from 'react'
import { Navigate, useNavigate } from '@tanstack/react-router'
import { useAiChatPage } from './datafetch'
import { AiChatPagePresentation } from './presentation'
import { useAuth } from '../_shared/authService'
import { useIsSignedInUserUnregistered } from '../_shared/backend-api/user'

export const AiChatPage: React.FC = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const isSignedInUserUnregistered = useIsSignedInUserUnregistered()
  const aiChatPageProps = useAiChatPage()

  // ユーザープールを作り直すと、残っているトークンの利用者は DB に居ない。チャットを送れないので、ログインし直してもらう
  useEffect(() => {
    if (auth.isAuthenticated && isSignedInUserUnregistered) {
      auth.logout()
      navigate({ to: '/signin' })
    }
  }, [auth, isSignedInUserUnregistered, navigate])

  if (!auth.isAuthenticated) {
    return <Navigate to="/signin" />
  }
  return <AiChatPagePresentation {...aiChatPageProps} />
}

export default AiChatPage
